import { render, staticRenderFns } from "./PowerupViewComponent.vue?vue&type=template&id=3e2db986&scoped=true"
import script from "./PowerupViewComponent.vue?vue&type=script&lang=ts"
export * from "./PowerupViewComponent.vue?vue&type=script&lang=ts"
import style0 from "./PowerupViewComponent.vue?vue&type=style&index=0&id=3e2db986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2db986",
  null
  
)

export default component.exports